<template>
  <div class="badge-block">
    <div class="transparent-box position-relative">
      <slot></slot>
      <loader v-if="loader"/>
    </div>
  </div>
</template>

<script>
import Loader from "../small_components/Loader";
export default {
  name: "TransparentBox",
  components: {Loader},
  props: {
    loader: {
      type: Boolean,
      default: false
    }
  }
}
</script>
